import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { InboxService } from '@hosty-app/services';

import { InboxStoreEffects } from './inbox-store.effects';
import { inboxStoreFeatureKey, reducer } from './inbox-store.reducers';

export function provideInboxStore(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState(inboxStoreFeatureKey, reducer),
    provideEffects([InboxStoreEffects]),
    InboxService,
  ]);
}
